import { ImageName, ImageDetails, UpdateImageRequest } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'

export class ImageApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  getImageDetails(name: ImageName): Promise<ImageDetails> {
    return this.edgeClient.getImage(name)
  }

  setImage(data: UpdateImageRequest): Promise<string> {
    return this.edgeClient.createImage(data)
  }
  deleteImage(name: ImageName): Promise<string> {
    return this.edgeClient.deleteImage(name)
  }
}
